import { Component, Input } from "@angular/core";

@Component({
  selector: "pms-page-datagrid-edit",
  template: "",
  standalone: false
})
export class PageDataGridEditComponent {
  @Input() allowAdding?: boolean;
  @Input() allowDeleting?: boolean;
  @Input() allowUpdating?: boolean;
  @Input() mode?: "batch" | "cell" | "row" | "form" | "popup";
}
